import { Component, Input, TemplateRef, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss']
})
export class AccordionComponent {
  @Input() title: string = '';
  @Input() contentTemplate!: TemplateRef<any>;
  @Input() isOpen: boolean = false;

  constructor(private cdRef: ChangeDetectorRef) {}

  toggleAccordion(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isOpen = !this.isOpen;
    this.cdRef.detectChanges(); // Manually trigger change detection
  }
}
